export enum ItemPermissionType {
  Guest = 'guest',
  Viewer = 'viewer',
  Contributor = 'contributor',
  Editor = 'editor',
  Owner = 'owner'
}

export enum ItemModalParams {
  Properties = 'itemId',
  Office = 'officeItemId',
  Drawing = 'drawingItemId',
  /** @public URL parameter used by external Files integrations. */
  Share = 'shareItemId',
  /** @public URL parameter used by external Files integrations. */
  Sign = 'signFileId'
}

export enum ItemQueryParams {
  FolderId = 'folderId',
  /** @public URL parameter used by external Files integrations. */
  Search = 'search'
}
